import React from "react";
import { Image } from "react-bootstrap";

import Button from "../../../../components/UI/Button/Button";
import callAlert from "../../../../assets/images/call-alert.svg";

import classes from "./Contact.module.css";
import { withTranslation } from "react-i18next";
// import firebase from "firebase";
// import moment from "moment";
import { logFirebaseEvent } from "../../../../shared/utility";
interface Props {
  modalClosed: () => void;
  contactText: string;
  contactNumber: string;
  email: string;
  t: any;
  logEvent: string;
}

const contactAlert: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, contactNumber, email, contactText } = { ...props };
  const btnStyle = {
    margin: "5px",
    width: "200px",
  };
  
  const emailHandler = () => {
    logFirebaseEvent(props.logEvent);
    window.location.href = `mailto:${email}`;
  };
  let { t } = props;
  return (
    <div className={classes.popupBody}>
      <div className={classes.closeBtn} onClick={modalClosed}>
        X
      </div>
      <h6>{contactText}</h6>
      <div className={classes.callAlert}>
        <h3>
          <Image src={callAlert} alt="call alert" />
          {contactNumber}
        </h3>
      </div>
      <Button
        label={t("contact.email")}
        clicked={emailHandler}
        style={btnStyle}
        displayImg={true}
        image="envelope.svg"
        disabled={false}
      />
    </div>
  );
};
export default withTranslation()(contactAlert);
